var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mx-3"},[_c('b-alert',{staticClass:"bg-danger pt-1 pb-0",attrs:{"show":""}},[_c('h5',{staticClass:"mt-2 text-white"},[_vm._v("Entorno de Desarrollo")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }